import React, { useEffect, useState, useRef } from "react";
import { ChatRoles } from "../../app/Enums/ChatRoles";
import "./User_Bot.css";
import "./User_Agent1.css"
import {
  getUsers,
  getUserBotChatDates,
  getUserBotChats,
  GetUsersSessionByEmail,
} from "../../Apis_chatbot/apis";
import Pagination from "../../app/components/Pagination/Pagination";
import Linkify from "linkify-react";
import * as linkify from "linkifyjs";
import agentProfileSvg from "../../assets/icons/agent-profile.svg";
import userProfileSvg from "../../assets/icons/user-profile.svg"

export default function User_Bot_Conversation() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [totalRows, setTotalRows] = useState(0);

  const [expandedUser, setExpandedUser] = useState(null);
  const [userSessions, setUserSessions] = useState({});
  const [selectedSession, setSelectedSession] = useState(null);
  const [chatDates, setChatDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [chats, setChats] = useState([]);

  const chatMessagesRef = useRef(null);

  const LinkifyProperties = {
    target: "_blank",
    rel: "noopener noreferrer",
    className: "chat-link"
  }
  // Fetch users
  useEffect(() => {
    fetchUsers();
  }, [currentPage, pageSize]);

  const fetchUsers = async () => {
    setLoading(true);
    const req = { pageNumber: currentPage, pageSize: pageSize };
    const res = await getUsers(req);
    if (res.result == 1 && !res.error) {
      setData(res.result_value || []);
      setTotalRows(res.total_row || 0);
    } else {
      setData([]);
      setTotalRows(0);
    }
    setLoading(false);
  };

  // --- Handle User Click ---
  const handleUserClick = async (user) => {
    // Collapse toggle
    if (expandedUser?.email !== null && expandedUser?.email === user.email) {
      setExpandedUser(null);
      setUserSessions({});
      setSelectedSession(null);
      setChatDates([]);
      setChats([]);
      return;
    }

    setExpandedUser(user);
    setSelectedSession(null);
    setChatDates([]);
    setChats([]);

    // Fetch sessions
    if(user?.email && user?.email!=="" && user?.email!=null && user?.email!==undefined){
    const sessionRes = await GetUsersSessionByEmail(user.email);
    if (sessionRes?.result_value?.length > 0) {
      // 🟢 User has sessions → show them
      setUserSessions((prev) => ({
        ...prev,
        [user.email]: sessionRes.result_value,
      }));
    } else {
      // 🔵 No sessions → directly fetch chat dates for this user
      setUserSessions((prev) => ({ ...prev, [user.email]: [] }));

      const res = await getUserBotChatDates(user.userId);
      if (res?.result_value) setChatDates(res.result_value);
      else setChatDates([]);
      setSelectedSession({ userId: user.userId, name: user.name });
    }
  }
  else{
    // 🔵 No sessions → directly fetch chat dates for this user
      setUserSessions((prev) => ({ ...prev, [user.email]: [] }));

      const res = await getUserBotChatDates(user.userId);
      if (res?.result_value) setChatDates(res.result_value);
      else setChatDates([]);
      setSelectedSession({ userId: user.userId, name: user.name });
  }
  };

  const getHeaderData = () => {
    //  Nothing selected
    if (!selectedSession) {
      return {
        text: "Select a conversation",
        showIcon: false,
      };
    }

    const name = selectedSession.name?.trim();
    const email = selectedSession.email?.trim();

    // Name exists → highest priority
    if (name) {
      return {
        text: name,
        showIcon: true,
      };
    }

    // Name missing, email exists
    if (email) {
      return {
        text: email,
        showIcon: true,
      };
    }

    // Nothing exists
    return {
      text: "Anonymous User",
      showIcon: true,
    };
  };

  const headerData = getHeaderData();


  // --- Handle Session Click ---
  const handleSessionClick = async (session) => {
    setSelectedSession(session);
    setSelectedDate(null);
    setChats([]);

    const res = await getUserBotChatDates(session.userId);
    if (res?.result_value) setChatDates(res.result_value);
    else setChatDates([]);
  };

  // --- Handle Date Click ---
  const handleDateClick = async (chatDate) => {
    setSelectedDate(chatDate);
    const res = await getUserBotChats(
      selectedSession?.userId || 0,
      chatDate.chatDate
    );
    if (res?.result_value) setChats(res.result_value);
    else setChats([]);
  };

  // --- Auto-scroll chat window ---
  useEffect(() => {
    const el = chatMessagesRef.current;
    if (el) el.scrollTo({ top: el.scrollHeight, behavior: "smooth" });
  }, [chats, selectedDate]);

  const totalPages = Math.ceil(totalRows / pageSize);

  return (
    <>
      <div className="role-box role-box2">
        <h2 className="mb-0">User - Bot Conversations</h2>
      </div>

      <div className="main-layout">
        {/* LEFT PANEL */}
        <div className="chat-box">
          <div className="user-list">
            <div className="userbot-agent-header">
              <h2>Conversations</h2>
            </div>
            <div className="usebot-body">
              {loading ? (
                <p className="loading">Loading...</p>
              ) : data.length === 0 ? (
                <p className="no-data">No users found</p>
              ) : (
                data.map((user, index) => (
                  <div key={index} className="user-section">
                    {/* USER CARD */}
                    <div
                      className={`conversation-card ${expandedUser?.userId === user.userId ? "active" : ""
                        }`}
                      onClick={() => handleUserClick(user)}
                    >
                      <div className="card-header">
                        <h4>{user.uniqueIdentity}</h4>
                        <span>
                          {new Date(user.createdAt).toLocaleDateString()}
                        </span>
                      </div>
                      <div className="card-body">
                        <p>
                          <strong>Name:</strong> {user.name || "N/A"}
                        </p>
                        <p>
                          <strong>Email:</strong> {user.email || "N/A"}
                        </p>
                      </div>
                    </div>

                    {/* SESSION CARDS */}
                    {expandedUser?.email === user.email &&
                      userSessions[user.email]?.map((session, idx) => (
                        <div
                          key={idx}
                          className={`session-card ${selectedSession?.userId === session.userId
                            ? "session-active"
                            : ""
                            }`}
                          onClick={() => handleSessionClick(session)}
                        >
                          <p>
                            <strong>Session:</strong> #{idx + 1}
                          </p>
                          <p>
                            <strong>Created:</strong>{" "}
                            {new Date(session.createdAt).toLocaleString()}
                          </p>
                          <p>
                            <strong>Name:</strong>{" "}
                            {session.name || "N/A"}
                          </p>
                        </div>
                      ))}
                  </div>
                ))
              )}
            </div>
          </div>
          <div className="sidebar-footer">
          {totalPages > 1 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
              pageSize={pageSize}
              onPageSizeChange={(size) => {
                setPageSize(size);
                setCurrentPage(1);
              }}
            />
          )}
          </div>
        </div>

        {/* RIGHT PANEL — Chats */}
        <div className="chat-section">
          <div className="agent-header d-flex align-items-center">
            {headerData.showIcon && (
                <img src={agentProfileSvg} alt="Profile" />
              )}
              <h2>{headerData.text}</h2>
          </div>
          <div className="user-bot-chat">
            {selectedSession ? (
              <div className="chat-wrapper">
                <div className="chat-container">
                  {/* Chat Dates */}
                  <div className="chat-dates">
                    {chatDates.length === 0 ? (
                      <p>No chat dates</p>
                    ) : (
                      chatDates.map((d, idx) => (
                        <div
                          key={idx}
                          className={`chat-date-item ${selectedDate?.chatDate === d.chatDate ? "active" : ""
                            }`}
                          onClick={() => handleDateClick(d)}
                        >
                          {new Date(d.chatDate).toLocaleDateString()}
                        </div>
                      ))
                    )}
                  </div>

                  {/* Chat Messages */}
                  <div className="chat-messages" ref={chatMessagesRef}>
                    {selectedDate ? (
                      chats.length === 0 ? (
                        <p>No chats for this date</p>
                      ) : (
                        chats.map((c, idx) => (
                          <div
                            key={idx}
                            className={`chat-message-wrapper ${c.sender_chatRole_id === ChatRoles.User
                              ? "left"
                              : "right"
                              }`}
                          >
                            <div
                              className={`chat-message ${c.sender_chatRole_id === ChatRoles.User
                                ? "user-msg"
                                : "bot-msg"
                                }`}
                            >
                              {/* <span className="role-label">
                              {ChatRoles[c.sender_chatRole_id]}
                            </span> */}
                              <img
                                src={
                                  ChatRoles[c.sender_chatRole_id] === "user"
                                    ? agentProfileSvg
                                    : userProfileSvg
                                }
                                alt="Profile"
                              />
                              {/* <p>{c.sendedMessage}</p> */}
                              <div>
                                <span className="time">
                                  {new Date(c.sendedTime).toLocaleTimeString()}
                                </span>
                                <p>
                                  <Linkify options={LinkifyProperties}>{c.sendedMessage}</Linkify>
                                </p>
                              </div>
                            </div>
                          </div>
                        ))
                      )
                    ) : (
                      <p className="select-date-msg">
                        Select a date to view chats
                      </p>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <div className="chat-placeholder">
                <p>Select a user or session to view chats</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
